(() => {
	// Local Data
	const localData = [
		{ name: 'Andy Phillips', birth: '1980', death: '2060', inTree: true, url: '?person=Andy_Phillips' },
		{ name: 'Bailey Stewart', birth: '1980', death: '2060', inTree: true, url: '?person=Bailey_Stewart' },
		{ name: 'Billy Hunter', birth: '1980', death: '2060', inTree: true, url: '?person=Billy_Hunter' },
		{ name: 'Bob Dowling', birth: '1980', death: '2060', inTree: true, url: '?person=Bob_Dowling' },
		{ name: 'Brett Wilson', birth: '1980', death: '2060', inTree: true, url: '?person=Brett_Wilson' },
		{ name: 'Carlos Filoteo', birth: '1980', death: '2060', inTree: true, url: '?person=Carlos_Filoteo' },
		{ name: 'David Godfrey', birth: '1980', death: '2060', inTree: true, url: '?person=David_Godfrey' },
		{ name: 'David Richardson', birth: '1980', death: '2060', inTree: true, url: '?person=David_Richardson' },
		{ name: 'Ed Pearson', birth: '1980', death: '2060', inTree: true, url: '?person=Ed_Pearson' },
		{ name: 'Eric Despain', birth: '1980', death: '2060', inTree: true, url: '?person=Eric_Despain' },
		{ name: 'Jake Hansen', birth: '1980', death: '2060', inTree: true, url: '?person=Jake_Hansen' },
		{ name: 'Jason Boyer', birth: '1980', death: '2060', inTree: true, url: '?person=Jason_Boyer' },
		{ name: 'Jason Bramble', birth: '1980', death: '2060', inTree: true, url: '?person=Jason_Bramble' },
		{ name: 'Jeff Gardner', birth: '1980', death: '2060', inTree: true, url: '?person=Jeff_Gardner' },
		{ name: 'Jeff Lord', birth: '1980', death: '2060', inTree: true, url: '?person=Jeff_Lord' },
		{ name: 'Kellie Hatch', birth: '1980', death: '2060', inTree: true, url: '?person=Kellie_Hatch' },
		{ name: 'Kim Belanger', birth: '1980', death: '2060', inTree: true, url: '?person=Kim_Belanger' },
		{ name: 'Kupono Yuen', birth: '1980', death: '2060', inTree: true, url: '?person=Kupono_Yuen' },
		{ name: 'Martin Pryzbyla', birth: '1980', death: '2060', inTree: true, url: '?person=Martin_Pryzbyla' },
		{ name: 'Mat Harb', birth: '1980', death: '2060', inTree: true, url: '?person=Mat_Harb' },
		{ name: 'Michael Burden', birth: '1980', death: '2060', inTree: true, url: '?person=Michael_Burden' },
		{ name: 'Mike Cook', birth: '1980', death: '2060', inTree: true, url: '?person=Mike_Cook' },
		{ name: 'Nate Bartlett', birth: '1980', death: '2060', inTree: true, url: '?person=Nate_Bartlett' },
		{ name: 'Peter Funk', birth: '1980', death: '2060', inTree: true, url: '?person=Peter_Funk' },
		{ name: 'Peter Mueller', birth: '1980', death: '2060', inTree: true, url: '?person=Peter_Mueller' }
	];

	// Default JSONP instantiation
	ui.autocomplete('#autocompleteDefault', {
		source: 'https://placepfx.ancestry.com/s/?&maxCount=10&cultureId=en',
		key: 'HName',
		queryParameter: 'prefix',
		dataType: 'jsonp',
		onChange: () => {
			console.log('here!');
		}
	});

	// Raw JSON - iTunes
	ui.autocomplete('#iTunes', {
		source: 'https://www.ancestrycdn.com/ui-standards-site/1.2.0/api/itunes-store-countries.json',
		key: 'name',
		highlight: true,
		minLength: 2,
		onItemSelect(data) {
			const features = data.features.join(', ');
			console.info(`iTunes Store Features: ${features}`); // eslint-disable-line
		}
	});

	// Custom Display - Names
	ui.autocomplete('#names', {
		source: 'https://www.ancestrycdn.com/ui-standards-site/1.2.0/api/random-names.json',
		key: 'name',
		minLength: 2,
		disableNoResultsMessage: true,
		customDisplay(data) {
			const sKeys = ['age', 'gender'];
			let displayText = data.value;
			displayText += ' <span class="autocompleteExtra">';
			for (let i = 0; i < sKeys.length; i++) {
				displayText += data.raw[sKeys[i]];
				if (i !== sKeys.length - 1) {
					displayText += ' | ';
				}
			}
			displayText += '</span>';
			return {
				checked: false,
				disabled: false,
				display: displayText,
				value: data.value
			};
		},
		onItemSelect() {
			if (this.value !== 'Mariah Molligan') {
				console.warn('You have chosen... poorly.'); // eslint-disable-line
			} else {
				console.info('You have chosen... wisely.'); // eslint-disable-line
			}
		}
	});

	// Custom XML Conversion
	ui.autocomplete('#xmlConversion2', {
		source: 'https://www.ancestrycdn.com/ui-standards-site/1.2.0/api/test-response.xml',
		key: 'suggestions',
		dataType: 'document',
		maxResults: 5,
		queryParameter: 'q',
		jsonConversion(data, options) {
			/* Custom Conversion Function */
			const sub = [];
			const prime = options.key;
			const jsonArray = [];
			let xml1 = [];
			let xml2 = [];
			// TODO: This is probably wrong
			const results = data.querySelectorAll(prime);
			for (let i = results.length - 1; i >= 0; i--) {
				xml1 = results[i].innerHTML;
				xml2 = xml1.split('|');
			}
			for (let i = xml2.length - 1; i >= 0; i--) {
				jsonArray[i] = {};
				sub[i] = xml2[i].substr(0, xml2[i].search(/\^/));
				jsonArray[i][prime] = sub[i];
			}
			return jsonArray;
		},
		onItemSelect(data) {
			console.log(data); // eslint-disable-line
		}
	});

	// Content Injection
	ui.autocomplete('#contentInject', {
		source: 'https://placepfx.ancestry.com/s/?&maxCount=6&cultureId=en',
		dataType: 'jsonp',
		key: 'HName',
		minLength: 2,
		queryParameter: 'prefix',
		alwaysOpenOnFocus: true,
		onOpen(resultContainer, before, after) {
			before.insertAdjacentHTML('beforeend', '<ul><li><button type="button" class="autocompleteResult link icon iconHome" id="yoTrigger2" type="button">Injected Content</button></li><ul>');
			after.insertAdjacentHTML('beforeend', '<ul><li><a class="autocompleteResult icon iconList" href="https://www.google.com/search?q=purpose+of+life" class="autocompleteResult">More Injected Content</a></li></ul>');
		}
	});

	// Group of fields
	ui.autocomplete('.placeGroup', {
		source: 'https://placepfx.ancestry.com/s/?maxCount=6&cultureId=en',
		key: 'HName',
		queryParameter: 'prefix',
		dataType: 'jsonp',
		ajaxOverride(ajaxObject) {
			return {
				data: {
					maxCount: 6,
					cultureId: 'en',
					prefix: ajaxObject.data.prefix
				}
			};
		}
	});

	ui.autocomplete('#preLoadedDataField', {
		source: localData, /* This must be an array of objects in order to work. */
		key: 'name',
		matchBeginning: true,
		minLength: 2
	});

	// Autocomplete in a modal
	const modalTrigger = document.getElementById('autocompleteModalTrigger');
	modalTrigger.addEventListener('click', () => {
		alert('Waiting on modal'); // eslint-disable-line
	});
	// modalTrigger.addEventListener('click', () => {
	// 	let autocompleteInstance;
	// 	ui.modal('#modalForAutocomplete', {
	// 		onOpen() {
	// 			autocompleteInstance = ui.autocomplete('#preLoadedDataFieldInModal', {
	// 				source: localData, /* This must be an array of objects in order to work. */
	// 				key: 'name',
	// 				minLength: 2
	// 			});
	// 		},
	// 		onClose() {
	// 			autocompleteInstance.destroy();
	// 		}
	// 	});
	// });

	// Autocomplete in a callout
	document.getElementById('personLookupTrigger').addEventListener('click', () => {
		alert('Waiting on callout'); // eslint-disable-line
	});
	// ui.callout('#personLookupTrigger', {
	// 	content: '#personLookup',
	// 	onAfterOpen() {
	// 		document.getElementById('personLookupField').focus();
	// 	}
	// });
	// ui.autocomplete('#personLookupField', {
	// 	alwaysOpenOnFocus: true,
	// 	source: localData,
	// 	minLength: 2,
	// 	maxResults: 10,
	// 	key: 'name',
	// 	customDisplay(data) {
	// 		return {
	// 			value: data.value,
	// 			display: `${data.display}, ${data.raw.birth}-${data.raw.death}`
	// 		};
	// 	},
	// 	onOpen($resultContainer, $before, $after) {
	// 		$after.innerHTML = document.getElementById('findPersonActions').innerHTML;
	// 	},
	// 	onItemSelect(itemData) {
	// 		alert(`Selected: ${itemData.name}\n Navigate to: ${itemData.url}`);
	// 		// window.location = itemData.url;
	// 	}
	// });

	// Autocomplete with badges
	ui.autocomplete('autocompleteWithBadgesInput', {
		source: localData,
		minLength: 2,
		maxResults: 10,
		key: 'name',
		onItemSelect(data) {
			const badgeContainer = document.getElementById('savedBadges');
			const newBadge = ` <button type="button" class="badge badgeSize1 badgeColor1 icon iconRemove badgeIconOnly320">${data.name}</button>`;
			badgeContainer.insertAdjacentHTML('beforeend', newBadge);
			this.value = '';
		}
	});

	const savedBadges = document.getElementById('savedBadges');
	savedBadges.addEventListener('click', e => {
		const btn = e.target.closest('.button');
		if (btn) {
			btn.remove();
		}
	});
})();



// WEBPACK FOOTER //
// ./src/components/autocomplete/autocomplete.demo.js